import React, { useState } from 'react';
import { Wrapper } from './star-rate.styled';

const stars = [1, 2, 3, 4, 5];

interface Props {
  rate: number;
  canRate: boolean;
  onRate: (newRate: number) => void;
  className?: string;
}

export const StarRate = React.memo(
  ({ rate, canRate, onRate, className }: Props) => {
    const [hoverRate, setHoverRate] = useState<number>(0);

    return (
      <Wrapper className={className} data-testid="star-rate" canRate={canRate}>
        {stars.map((star, index) => {
          const starValue = index + 1;
          const isActive = starValue <= (hoverRate || rate);

          return (
            <span
              key={index}
              title={String(starValue)}
              onClick={() => canRate && onRate(starValue)}
              onMouseEnter={() => canRate && setHoverRate(starValue)}
              onMouseLeave={() => canRate && setHoverRate(0)}
              className={isActive ? 'fas fa-star' : 'far fa-star'}
            />
          );
        })}
      </Wrapper>
    );
  }
);
